import React from 'react';
import DataTable from '../../../../components/DataTable';
import countryImport from '../../../../ExcelFiles/country.xlsx';

const SupportCountry = () => {

    let columns = ["name", "code", "currency_type", "currency_symbol"]
    let headers = ["Name", "Code", "Currency Type", "Currency Symbol"];
    let excelheader = ["name", "code", "currency_type", "currency_symbol"]


    let addform = [
        { 'name': 'name', 'label': 'Name', 'type': 'short-text', 'addVali': 'required' },
        { 'name': 'code', 'label': 'Code', 'type': 'short-text', 'addVali': 'required|max:10' },
        { 'name': 'currency_type', 'label': 'Currency Type', 'type': 'short-text', 'addVali': 'required|max:30' },
        { 'name': 'currency_symbol', 'label': 'Currency Symbol', 'type': 'short-text', 'addVali': 'required|max:5' },
    ]

    return (
        <DataTable
            url="country/"
            column={columns}
            header={headers}
            title='Countries'
            addform={addform}
            excelheader={excelheader}
            excelurl="country-import/"
            successMessage="Added Successfully"
            filePath={countryImport}
            filename="Countries.xlsx"
        />
    );
};

export default SupportCountry;